import { differenceInDays, format, parse } from "date-fns";
import { ChecklistItem } from "./ChecklistItem";
import { Countable } from "./common";
import { Task } from "./Task";
import colorLib from "@kurkle/color";


export function transparentize(value: string, opacity: number) {
    var alpha = opacity === undefined ? 0.5 : 1 - opacity;
    return colorLib(value || "#FAFAFA").alpha(alpha).rgbString();
}

export interface TimeSum {
    minutes: number
    asString: string
}

export function addTimeSums(a: TimeSum, b: TimeSum): TimeSum {
    const total = a.minutes + b.minutes;
    return {
        minutes: total,
        asString: formatMins(total)
    }
}

export function parseMins(value: string): number {
    if (value === "00:00") return 0;
    let parts = value.split(':');
    return 60 * parseInt(parts[0]) + parseInt(parts[1]);
}

export function formatMins(value: number): string {
    const hours = Math.floor(value / 60);
    const mins = value - hours * 60;
    let result = [];
    if (hours > 0) {
        result.push(`${hours} ч.`);
    }
    if (mins > 0) {
        result.push(`${mins} мин.`)
    }
    if (result.length > 0) {
        return result.join(' ')
    }
    return '0 ч.'
}
export function formatMinsSimple(value: number): string {
    const hours = Math.floor(value / 60);
    const mins = value - hours * 60;

    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`
}
export function totalTime(items: Array<Countable>): TimeSum {
    // Возвращает сумму времени в минутах на указанные задачи
    let totalMins = 0;
    items.map(item => {
        totalMins += parseMins(item.needTime || "00:00");
    })
    return {
        minutes: totalMins,
        asString: formatMins(totalMins)
    }
}


export function sortChecklistItems(tasks: ChecklistItem[]) {
    return tasks.sort((a, b) => (a.order || 0) - (b.order || 0))
}

export function deadlineColor(deadline?: string | Date): string {
    let dt;
    if (typeof deadline === "string") {
        dt = parse(deadline, "yyyy-MM-dd", new Date());
    } else {
        dt = deadline
    }
    if (dt) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const todayStr = format(today, "yyyy-MM-dd");
        const deadlineStr = format(dt, "yyyy-MM-dd");
        const diffDays = differenceInDays(dt, today);
        
        // Дедлайн сегодня или просрочен
        if (diffDays <= 0) {
            return 'danger';
        }
        // Дедлайн на текущей неделе (7 дней или меньше)
        else if (diffDays <= 7) {
            return 'warning';
        }
        // Более недели до дедлайна
        else {
            return 'info';
        }
    }
    return ""
}